import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=916adcd6&scoped=true&"
import script from "./Introduction.vue?vue&type=script&lang=ts&"
export * from "./Introduction.vue?vue&type=script&lang=ts&"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=916adcd6&lang=scss&scoped=true&"
import style1 from "./Introduction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916adcd6",
  null
  
)

export default component.exports